(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AgenceDeleteController',AgenceDeleteController);

    AgenceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Agence'];

    function AgenceDeleteController($uibModalInstance, entity, Agence) {
        var vm = this;
        vm.agence = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Agence.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
